module.exports = __webpack_public_path__ + "img/back-pink.a6429500.svg";